import type { UiMessages } from "../types";

export const de: UiMessages = {
  nav: {
    streams: "Streams",
    videos: "Videos",
    shorts: "Shorts",
    forYou: "Für dich",
    vr: "VR",
    cartoon: "Cartoon",
    hentai: "Hentai",
    sections: "Mehr",
    menu: "Menü",
    game: "Pornospiel",
    stories: "Sexgeschichten",
    escorts: "Escorts",
    ai: "KI-Freundinnen",
    paysites: "Premium-Seiten",
    home: "Startseite",
    following: "Gefolgt",
    watching: "Verlauf",
    rankings: "Ranglisten",
    invite: "Freunde einladen",
    coins: "Sweet Coin",
    achievements: "Erfolge",
    hot: "Gerade heiß",
    random: "Zufallsvideo",
    saved: "Gespeichert",
    reacted: "Reaktionen",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Pornostars",
    productions: "Studios",
    categories: "Kategorien",
    telegram: "Telegram-Kanal",
    allSections: "Alle Bereiche",
    mainNavigation: "Hauptnavigation",
    quickNavigation: "Schnellnavigation",
    show: "Anzeigen",
    coinsReady: "Sweet Coins zum Abholen bereit",
    logIn: "Anmelden",
    search: "Suchen",
    closeSearch: "Suche schließen",
    language: "Sprache",
    theme: "Design",
    themeDark: "Dunkel",
    themeLight: "Hell",
  },
  age: {
    parents: "Eltern: Unsere Seite {link} erklärt, wie du den Zugang zu dieser Website sperrst. Sweet ist mit dem RTA-Label gekennzeichnet.",
    parentalControls: "Jugendschutz",
    title: "Dies ist eine Website für Erwachsene",
    body: "Diese Website enthält altersbeschränkte Inhalte, darunter Nacktheit und explizite Darstellungen sexueller Handlungen. Mit dem Betreten bestätigst du, dass du mindestens 18 Jahre alt bist oder das Volljährigkeitsalter des Landes erreicht hast, von dem aus du die Website aufrufst, und dass du dem Ansehen sexuell expliziter Inhalte zustimmst.",
    enter: "Ich bin 18 oder älter – Betreten",
    exit: "Ich bin unter 18 – Verlassen",
  },
  consent: {
    title: "Cookies",
    body: "Sweet ist dank Werbung kostenlos. Unsere Werbepartner nutzen Cookies, um Anzeigen zu zeigen und deren Aufrufe und Klicks zu zählen. Notwendige Speicherung, etwa deine Altersbestätigung, funktioniert so oder so.",
    privacy: "Datenschutzerklärung",
    acceptAll: "Alle akzeptieren",
    onlyNecessary: "Nur notwendige",
    settings: "Cookie-Einstellungen",
  },
  ago: { now: "jetzt", m: "{n} Min.", h: "{n} Std.", d: "{n} Tg.", w: "{n} Wo.", mo: "{n} Mon.", y: "{n} J." },
  cams: {
    allPlatforms: "Alle Plattformen",
    watchOnSite: "Auf {site} ansehen",
    liveFor: "live seit {time}",
    tryAnother: "Probiere einen anderen Tag oder eine andere Region oder schau später noch mal vorbei.",
    nobodyLiveOn: "Gerade ist niemand live auf {name}",
    platformShowUpHint: "Streams von {name} erscheinen hier, sobald sie starten. Schau gleich noch mal vorbei.",
    liveNowCount: "{n} jetzt live",
    opensOn: "sie öffnen sich auf {site}",
    streamerSite: "der Seite des Streams",
    orWatch: "Oder schau dir {link} an.",
    videoTag: "#{tag}-Videos",
    liveStreams: "Livestreams",
    platformStreams: "{name} Livestreams",
    liveCams: "Live Cams",
    platformCams: "{name} Cams",
    moreLiveCams: "Mehr Live Cams",
    byTopic: "Live Cams nach Thema",
    breadcrumb: "Brotkrümelnavigation",
    live: "Live",
    viewers: "Zuschauer:",
    isLive: "{name} ist live",
    watchOn: "{title} — live auf {site} ansehen",
    nobodyLive: "Gerade ist niemand live",
    noMatch: "Keine Livestreams passen zu diesen Filtern",
    showUpHint: "Streams erscheinen hier, sobald sie starten. Schau in Kürze wieder vorbei.",
    clearFilters: "Filter zurücksetzen",
    clearAll: "Alle zurücksetzen",
    clear: "Zurücksetzen",
    seeAllPlatforms: "Alle Plattformen ansehen",
    watchVideos: "Videos ansehen",
    onPlatform: " auf {name}",
    newOnTelegram: "Neue Live Cams auf Telegram",
    loadMoreFailed: "Laden fehlgeschlagen – versuch es noch mal",
    platforms: "Plattformen",
    streamPlatforms: "Stream-Plattformen",
    platformsAndFilters: "Stream-Plattformen und Filter",
    categories: "Kategorien",
    all: "Alle",
    region: "Region",
    allRegions: "Alle Regionen",
    more: "Mehr",
    newModels: "Neue Models",
    tags: "Tags",
    removeTag: "Tag entfernen",
    remove: "Entfernen",
    loading: "Wird geladen",
    offline: "Offline",
    seeAll: "Alle ansehen",
    genders: { female: "Frauen", male: "Männer", couple: "Paare", trans: "Trans" },
    regions: { north_america: "Nordamerikanisch", south_america: "Südamerikanisch", europe: "Europäisch & Russisch", asia: "Asiatisch", other: "Andere Regionen" },
  },
  video: {
    fullScene: "Die ganze Szene auf {site} ansehen",
    upNext: "Als Nächstes",
    nextPage: "Nächste Seite",
    moreVideos: "Mehr Videos",
    end: "Du bist am Ende angekommen.",
    loadMoreFailed: "Laden fehlgeschlagen – versuch es noch mal",
    likes: "Likes",
    premiumVideo: "Premium-Video",
    subscribeToWatch: "Abonniere, um dieses Video in voller Länge zu sehen.",
    getPremium: "Premium holen",
    logIn: "Anmelden",
    playsIn: "Läuft im Player von {name}",
    partnerBlocked: "Das Video läuft über die Server von {name}, die aus deinem Netz nicht erreichbar sind: {name} ist vielleicht von deinem Internetanbieter oder in deinem Land gesperrt.",
    unavailable: "{name} zeigt seine Videos in deinem Land nicht, daher kannst du dieses hier nicht ansehen.",
    watchCams: "Stattdessen Live Cams ansehen",
    chatLive: "Live-Chat mit {name} auf {site}",
    play: "{title} abspielen",
    sponsored: "Gesponsert",
    onlyfansCreators: "OnlyFans-Creator",
    liveNowFree: "Jetzt live · kostenlos",
    allVideos: "Alle Videos",
    stoppedAt: "Gestoppt bei {at} von {of}",
    watchedToEnd: "Bis zum Ende angesehen",
  },
  profile: { followers: "Follower", views: "Aufrufe", videos: "Videos", verified: "Verifiziert", follow: "Folgen", unfollow: "Entfolgen" },
  lists: {
    categories: "Kategorien",
    popular: "Beliebt",
    aToZ: "A – Z",
    jumpToLetter: "Zum Buchstaben springen",
    allCategories: "Alle Kategorien",
    noVideosYet: "Hier gibt es noch keine Videos",
    pageN: "Seite {n}",
    newEveryDay: "Jeden Tag kommen neue Videos dazu.",
    videoCount: "{n} Videos",
    pornstars: "Pornostars",
    pornstarsIntro: "Die Creator mit den meisten Followern diese Woche.",
    studios: "Pornostudios",
    studiosIntro: "Produktionsfirmen und Kanäle, sortiert nach Followern.",
    noVideosWithTag: "Keine Videos mit diesem Tag",
    showAllVideos: "Alle Videos anzeigen",
  },
  hot: {
    title: "Gerade heiß",
    intro: "Die Videos, die auf Sweet in den letzten Stunden am meisten geschaut werden.",
  },
  comments: {
    title: "Kommentare",
    placeholder: "Kommentar schreiben…",
    post: "Senden",
    login: "Zum Kommentieren anmelden",
    coinsHint: "+{n} Münzen für jeden deiner ersten {max} Kommentare am Tag",
    earned: "+{n} Münzen",
    empty: "Noch keine Kommentare. Sei der Erste.",
    more: "Mehr anzeigen",
    delete: "Löschen",
    short: "Schreib etwas mehr.",
    long: "Zu lang: höchstens {n} Zeichen.",
    links: "Links und Kontaktdaten sind in Kommentaren nicht erlaubt.",
    forbidden: "Dieser Kommentar kann nicht veröffentlicht werden.",
    rate: "Du kommentierst zu schnell. Versuch es später noch einmal.",
    duplicate: "Das hast du schon gepostet.",
    failed: "Konnte nicht gesendet werden. Versuch es noch einmal.",
    like: "Gefällt mir",
    dislike: "Gefällt mir nicht",
    rateLogin: "Melde dich an, um Videos zu bewerten",
    liked: "{p}% gefällt es",
  },
  starVote: {
    title: "Star des Monats",
    vote: "Abstimmen",
    voteFor: "Stimme für {name} als Star des Monats",
    voteAgain: "Noch mal · {n} Münzen",
    confirm: "{n} Münzen ausgeben?",
    standing: "Platz {rank} diesen Monat · Stimmen: {n}",
    noVotes: "Diesen Monat noch keine Stimmen",
    thanks: "Danke für deine Stimme!",
    paidThanks: "Stimme gezählt · −{n} Münzen",
    coins: "Nicht genug Münzen: Eine Stimme kostet {n}.",
    limit: "Das waren alle Stimmen für heute.",
    rules: "Eine Gratisstimme pro Tag, danach {n} Münzen pro Stimme.",
    boardIntro: "Mitglieder stimmen auf den Seiten der Stars für ihre Lieblinge ab: eine Gratisstimme pro Tag, weitere für je {n} Münzen.",
    boardEmpty: "Diesen Monat noch keine Stimmen. Stimme auf der Seite eines Stars ab.",
    votes: "Stimmen",
    lastWinner: "Star des letzten Monats",
    login: "Zum Abstimmen anmelden",
  },
  achievements: {
    title: "Erfolge",
    intro: "Schalte Erfolge frei, während du schaust, folgst und mitmachst. Jeder bringt Sweet Coins.",
    unlocked: "Freigeschaltet",
    coins: "+{n} Münzen",
    progress: "{x} von {n}",
    total: "{x} von {n} freigeschaltet",
    login: "Melde dich an, um Erfolge und ihre Münzen zu sammeln.",
    signup: "Konto erstellen",
    toast: "Erfolg freigeschaltet",
    names: {
      "videos-1": ["Erstes Video", "Sieh dir dein erstes Video an"],
      "videos-10": ["Aufgewärmt", "Sieh dir 10 Videos an"],
      "videos-100": ["Stammgast", "Sieh dir 100 Videos an"],
      "videos-1000": ["Kenner", "Sieh dir 1.000 Videos an"],
      "hours-1": ["Eine Stunde", "Schau eine Stunde lang"],
      "hours-10": ["Zehn Stunden", "Schau 10 Stunden lang"],
      "hours-100": ["Marathon", "Schau 100 Stunden lang"],
      "streak-3": ["Drei am Stück", "Schau an 3 Tagen hintereinander"],
      "streak-7": ["Wochenserie", "Schau eine Woche lang jeden Tag"],
      "streak-30": ["Monatsserie", "Schau 30 Tage lang jeden Tag"],
      "follows-5": ["Fan", "Folge 5 Stars oder Studios"],
      "likes-25": ["Großes Herz", "Like 25 Videos"],
      "saves-10": ["Sammler", "Speichere 10 Videos"],
      "days-7": ["Münzwoche", "Sammle an 7 Tagen Münzen"],
      "days-30": ["Münzmonat", "Sammle an 30 Tagen Münzen"],
      "invites-1": ["Bring einen Freund mit", "Lade einen Freund ein, der sich registriert"],
      "comments-1": ["Erste Worte", "Schreib deinen ersten Kommentar"],
      "comments-25": ["Gesprächig", "Schreib 25 Kommentare"],
      "votes-1": ["Wähler", "Stimme für einen Star des Monats ab"],
    },
  },
  pwa: {
    appName: "Sweet-App",
    bannerLabel: "App installieren",
    bannerPitch: "Vollbild, ohne App Store",
    install: "Installieren",
    notNow: "Nicht jetzt",
    installApp: "App installieren",
    howToInstall: "So installierst du sie",
    inApp: "Du nutzt die App.",
    cardPitch: "Vollbild, mit einem Tipp vom Home-Bildschirm. Kein App Store nötig.",
    manual: "Öffne das Browsermenü und wähle {install} oder {add}.",
    iosTitle: "Sweet zum Home-Bildschirm hinzufügen",
    iosShare: "Tippe in der Browserleiste auf {share} (unter iOS 26: {more}, dann {share})",
    iosAdd: "Wähle {add}",
    iosConfirm: "Tippe auf {confirm}: Sweet öffnet sich im Vollbild vom Home-Bildschirm",
    share: "Teilen",
    more: "•••",
    add: "Zum Home-Bildschirm",
    confirm: "Hinzufügen",
    installMenu: "App installieren",
    gotIt: "Verstanden",
    close: "Schließen",
    offlineTitle: "Du bist offline",
    offlineBody: "Sweet braucht Internet für Videos und Cams. Prüfe deine Verbindung und versuche es erneut.",
    retry: "Erneut versuchen",
    recent: "Zuletzt geöffnet",
  },
  notifications: {
    title: "Benachrichtigungen",
    empty: "Noch nichts Neues. Folge Stars und Studios oder füge Cam-Models zu deinen Favoriten hinzu, dann erscheinen ihre Neuigkeiten hier.",
    newVideos: "Neue Videos",
    liveNow: "Jetzt live",
    markRead: "Alle als gelesen markieren",
    pushOn: "Benachrichtigungen einschalten",
    pushOff: "Benachrichtigungen ausschalten",
    pushHint: "Erfahre von neuen Videos und Live-Favoriten, auch wenn Sweet geschlossen ist.",
    pushBlocked: "Benachrichtigungen für Sweet sind in deinen Browsereinstellungen blockiert.",
    pushUnsupported: "Dieser Browser kann keine Benachrichtigungen anzeigen. Auf dem iPhone füge Sweet zuerst zum Home-Bildschirm hinzu.",
    pushEnabled: "Benachrichtigungen sind an",
    favorites: "Lieblings-Models",
    addFavorite: "Zu Favoriten hinzufügen",
    removeFavorite: "Aus Favoriten entfernen",
    favoritesEmpty: "Noch keine Lieblings-Models. Tippe auf das Herz bei einer Cam, um eins hinzuzufügen.",
    offline: "Offline",
    viewAll: "Alle ansehen",
  },
  forYou: {
    title: "Für dich",
    all: "Alle",
    continueWatching: "Weiterschauen",
    intro: "Ausgewählt nach dem, was du likst, speicherst, schaust und wem du folgst.",
    empty: "Like, speichere oder folge ein paar Videos und Stars, dann findest du hier Videos für dich.",
    more: "Mehr",
  },
  shorts: {
    straight: "Hetero",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Ganzes Video ansehen",
    like: "Gefällt mir",
    liked: "Gefällt dir",
    save: "Speichern",
    saved: "Gespeichert",
    share: "Teilen",
    copied: "Link kopiert",
    soundOn: "Ton einschalten",
    soundOff: "Ton ausschalten",
    tapForSound: "Für Ton tippen",
    report: "Melden",
    follow: "Folgen",
    following: "Folgst du",
    previous: "Zurück",
    next: "Weiter",
    close: "Schließen",
    end: "Das war's fürs Erste. Mehr unter Videos.",
    empty: "Hier gibt es noch keine Shorts.",
    live: "Live",
    watchLive: "Gratis live ansehen",
    watching: "{n} schauen zu",
    profile: "Profil",
    moreLive: "Mehr Live-Cams",
  },
  search: {
    searches: "Suchen",
    popular: "Beliebte Suchen",
    categories: "Kategorien",
    searchFor: "Videos suchen: „{q}“",
    nothingFor: "Nichts gefunden für „{q}“.",
    title: "Sweet durchsuchen",
    placeholder: "Videos, Personen und Marken suchen",
    hint: "Finde Videos, Stars, Produktionen und Kategorien. Drück überall /, um loszutippen.",
    stars: "Stars",
    productions: "Produktionen",
    other: "Sonstiges",
    otherProfiles: "Weitere Profile",
    nothing: "Nichts gefunden",
    tryAgain: "Prüf die Schreibweise oder versuch einen allgemeineren Begriff.",
    backHome: "Zurück zur Startseite",
  },
  notFound: { title: "Diese Seite gibt es nicht", body: "Das Video wurde vielleicht entfernt, oder der Link ist falsch geschrieben.", home: "Zur Startseite" },
  common: {
    close: "Schließen",
    copy: "Kopieren",
    copied: "Kopiert",
    more: "Mehr",
    loading: "Wird geladen",
    clearAll: "Alles löschen",
    browseVideos: "Videos ansehen",
    scrollLeft: "Nach links scrollen",
    scrollRight: "Nach rechts scrollen",
  },
  actions: {
    react: "Gefällt mir",
    reacted: "Gefällt dir",
    save: "Speichern",
    saved: "Gespeichert",
    follow: "Folgen",
    following: "Du folgst",
    followName: "{name} folgen",
    unfollowName: "{name} entfolgen",
    moreOptions: "Weitere Optionen",
    share: "Teilen",
    copyLink: "Link kopieren",
    linkCopied: "Link kopiert",
    report: "Melden",
    home: "Sweet — Startseite",
    onSweet: "{name} auf Sweet",
    joinMe: "Komm zu mir auf Sweet",
    inviteLink: "Dein Einladungslink",
  },
  library: {
    savedEmpty: "Noch nichts gespeichert",
    savedHint: "Tippe unter einem Video auf das Lesezeichen, um es hier zu behalten. Deine Liste wird nur auf diesem Gerät gespeichert.",
    reactedEmpty: "Noch keine Reaktionen",
    reactedHint: "Videos mit deinem Herz erscheinen hier, die neuesten zuerst.",
    watchingEmpty: "Noch nichts angesehen",
    watchingHint: "Videos, die du abspielst, erscheinen hier mit der genauen Stelle, an der du aufgehört hast, und laufen dort weiter, wenn du sie wieder öffnest.",
    removeWatching: "Aus dem Verlauf entfernen",
    removeVideo: "{title} aus dem Verlauf entfernen",
    followingEmpty: "Du folgst noch niemandem",
    followingHint: "Tippe bei einem Model oder Studio auf +, und ihre neuesten Videos sammeln sich hier. Gefolgte Profile werden nur auf diesem Gerät gespeichert.",
    discoverModels: "Models entdecken",
    noVideosHint: "Probier eine andere Kategorie — jeden Tag kommen neue Videos dazu.",
    backToAll: "Zurück zu allen Videos",
  },
  player: {
    resumesAt: "Weiter ab {at}",
    startOver: "Von vorn",
    unavailable: "Dieses Video ist gerade nicht verfügbar.",
    play: "Abspielen",
    pause: "Pause",
    seek: "Spulen",
    back10: "10 Sekunden zurück",
    forward10: "10 Sekunden vor",
    mute: "Stumm",
    unmute: "Ton an",
    volume: "Lautstärke",
    settings: "Einstellungen",
    pip: "Bild-in-Bild",
    fullscreen: "Vollbild",
    exitFullscreen: "Vollbild beenden",
    quality: "Qualität",
    speed: "Wiedergabegeschwindigkeit",
    normal: "Normal",
    auto: "Auto",
    partner: "der Partner",
  },
  ads: { ad: "Werbung", advertisement: "Werbung", muteAd: "Werbung stumm schalten", unmuteAd: "Ton der Werbung an", skipIn: "Überspringen in {n}", skipAd: "Werbung überspringen ›" },
  auth: {
    username: "Benutzername",
    usernameOrEmail: "Benutzername oder E-Mail",
    emailOptional: "E-Mail (optional)",
    password: "Passwort",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    confirmNewPassword: "Neues Passwort bestätigen",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
    forgot: "Passwort vergessen?",
    remember: "Angemeldet bleiben",
    logIn: "Anmelden",
    createAccount: "Konto erstellen",
    usernameHelp: "3–24 Buchstaben, Ziffern, Punkte oder Unterstriche. Wird in den Ranglisten angezeigt.",
    emailHelp: "Nur zum Zurücksetzen deines Passworts. Du kannst sie später in deinem Konto hinzufügen.",
    passwordHelp: "Mindestens 8 Zeichen.",
    adult: "Ich bin 18 Jahre oder älter.",
    agree: "Ich akzeptiere die {terms} und die {privacy}.",
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutzerklärung",
    savePhrasesTitle: "Speichere deine Wiederherstellungsphrasen",
    savePhrasesBody: "Du hast dich ohne E-Mail registriert. Mit diesen Phrasen kommst du wieder rein, falls du dein Passwort vergisst.",
    continue: "Weiter",
    resetHow: "So setzt du dein Passwort zurück",
    byEmail: "Link per E-Mail",
    byPhrase: "Wiederherstellungsphrase",
    phraseIntro: "Für Konten ohne E-Mail: Gib deinen Benutzernamen und eine der Wiederherstellungsphrasen ein, die du bei der Registrierung gespeichert hast.",
    phrase: "Wiederherstellungsphrase",
    phrasePlaceholder: "Wort Wort Wort Wort",
    phraseHelp: "Die 4 Wörter einer Phrase. Jede Phrase funktioniert einmal.",
    saveNewPassword: "Neues Passwort speichern",
    sendLink: "Link zum Zurücksetzen senden",
  },
  phrases: {
    warning: "Speichere sie jetzt: Sie werden nicht noch einmal angezeigt. Wenn du dein Passwort vergisst, kannst du mit deinem Benutzernamen und einer dieser Phrasen ein neues wählen. Jede Phrase funktioniert einmal. Halte sie geheim.",
    list: "Deine Wiederherstellungsphrasen",
    copyAll: "Alle kopieren",
    download: ".txt herunterladen",
    savedCheck: "Ich habe meine Wiederherstellungsphrasen sicher aufbewahrt.",
    done: "Fertig",
    fileTitle: "Sweet-Wiederherstellungsphrasen für @{username}",
    fileHow: "Wenn du dein Passwort vergisst, öffne {url}, wähle „{option}“ und gib deinen Benutzernamen und eine dieser Phrasen ein.",
    filePrivate: "Jede Phrase funktioniert einmal. Halte sie geheim: Wer deinen Benutzernamen und eine dieser Phrasen hat, kann dein Konto übernehmen.",
    none: "Dein Konto hat weder E-Mail noch Wiederherstellungsphrasen. Wenn du dein Passwort vergisst, kommst du nicht mehr rein. Erstelle jetzt Wiederherstellungsphrasen.",
    optional: "Mit Wiederherstellungsphrasen wählst du ohne E-Mail ein neues Passwort. Optional, solange dein Konto eine E-Mail hat.",
    left: "{left} von {total} Phrasen unbenutzt.",
    leftMade: "{left} von {total} Phrasen unbenutzt, erstellt am {date}.",
    how: "Jede davon lässt dich zusammen mit deinem Benutzernamen einmal ein neues Passwort wählen. Verloren? Erstelle neue, dann funktionieren die alten nicht mehr.",
    make: "Wiederherstellungsphrasen erstellen",
    makeNew: "Neue Phrasen erstellen",
  },
  account: {
    menu: "Kontomenü",
    settings: "Kontoeinstellungen",
    profiles: "Deine Profile",
    logOut: "Abmelden",
    uploadPhoto: "Foto hochladen",
    removePhoto: "Aktuelles Foto entfernen",
    displayName: "Anzeigename",
    showInRankings: "In den Ranglisten zeigen",
    rankingsHelp: "Dein Name, dein Foto und deine Statistiken erscheinen in den öffentlichen {link}. Schalte das aus, um nicht aufzutauchen; deine Zeit wird trotzdem gezählt.",
    save: "Speichern",
    emailHelp: "Nur für einen Link, falls du dein Passwort vergisst. Lass das Feld leer, um sie zu entfernen.",
    saveEmail: "E-Mail speichern",
    changePassword: "Passwort ändern",
    deleteWarning: "Damit werden dein Konto, deine gespeicherten Videos, Reaktionen und gefolgten Profile endgültig gelöscht. Das lässt sich nicht rückgängig machen.",
    typeToConfirm: "Gib zur Bestätigung {word} ein",
    deleteMine: "Mein Konto löschen",
  },
  pay: {
    billingPeriod: "Abrechnungszeitraum",
    monthly: "Monatlich",
    yearly: "Jährlich",
    yourPlan: "Dein Paket",
    month: "Monat",
    year: "Jahr",
    oneMonth: "1 Monat",
    months: "{n} Monate",
    oneYear: "1 Jahr",
    years: "{n} Jahre",
    perMonth: "{price} pro Monat",
    save: "{n} % sparen",
    comingSoon: "Demnächst",
    reward: "−{n} % deine Belohnung",
    plays: "{n} Spiele in Sweet Room",
    addedAtOnce: "Sofort gutgeschrieben",
    get: "{plan} holen",
    addMonth: "Einen Monat dazu",
    addYear: "Ein Jahr dazu",
    opensSoon: "Zahlungen starten bald",
    alreadyMember: "Schon Mitglied?",
    choose: "Zahlungsart wählen",
    payWith: "Bezahlen mit",
    starsInBot: "{n} Stars in unserem Telegram-Bot",
    card: "Karte",
    crypto: "Krypto",
    cryptoMore: "BTC, USDT, ETH, TON und 30+ weitere",
    tooManyStars: "Zu viel für eine einzige Zahlung mit Telegram Stars.",
    cardMin: "Kartenzahlungen ab {price}.",
    payStars: "Mit Telegram Stars bezahlen",
    preparing: "Bezahlung wird vorbereitet…",
    loginFirst: "Melde dich zuerst an",
    cantStart: "Bezahlung kann nicht gestartet werden",
    noAdsCoins: "Keine Werbung + {n} Sweet Coins",
    addedOnPay: "Wird deinem Guthaben gutgeschrieben, sobald du bezahlst",
    payInTelegram: "In Telegram bezahlen",
    waitingStars: "Warte auf deine Zahlung — diese Seite aktualisiert sich von selbst",
    allSet: "Alles erledigt!",
    noAds: "Keine Werbung mehr.",
    noAdsUntil: "Keine Werbung bis {date}.",
    coinsAdded: "{n} Münzen sind auf deinem Guthaben.",
    startWatching: "Jetzt ansehen",
    great: "Super",
    payCard: "Mit Karte bezahlen",
    failedTitle: "Die Zahlung ist nicht durchgegangen",
    failedBody: "Es wurde nichts abgebucht. Du kannst es noch einmal versuchen.",
    newTab: "Bezahle im neuen Tab",
    newTabBody: "Karte, Apple Pay oder Google Pay auf der sicheren Seite von Chain2Pay. Diese Seite aktualisiert sich von selbst, sobald bezahlt ist.",
    waiting: "Warte auf deine Zahlung…",
    openAgain: "Zahlungsseite erneut öffnen",
    somethingWrong: "Etwas ist schiefgelaufen. Versuch es in einer Minute noch einmal.",
    offline: "Du scheinst offline zu sein. Versuch es in einer Minute noch einmal.",
    bestValue: "Bester Preis",
    coins: "Münzen",
    orStars: "oder {n} Stars",
    packsSoon: "Münzpakete gibt es schon bald.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins eingesammelt!",
    collectedToday: "Heute eingesammelt",
    nextBonus: "Nächster Bonus in",
    collecting: "Wird eingesammelt…",
    collect: "{n} Sweet Coins einsammeln",
    alreadyCollected: "Du hast die Münzen von heute schon eingesammelt. Komm morgen wieder.",
    offerLabel: "Sweet Coins und Premium",
    offerTitle: "Hol dir Sweet Coins",
    offerFor: "Für Sweet Room und kostenpflichtige Videos",
    premiumFrom: "Premium ab {price}",
    upTo: "Keine Werbung + bis zu {n} Münzen",
    packsFrom: "Münzpakete ab {price}",
    collectFree: "Oder sammle jeden Tag gratis Münzen",
    offerButton: "Sweet-Coins-Angebot",
    guestCollected: "+{n} Sweet Coins! Damit du deine Münzen nicht verlierst, registriere dich bei Sweet.",
    guestKeep: "Ohne Konto bleiben Münzen {days} Tage erhalten und verfallen dann.",
    guestSignup: "Kostenlos registrieren und behalten",
    guestLogin: "Schon ein Konto? Anmelden",
    guestExpire: "{n} Münzen verfallen am {date}.",
    guestUnsaved: "Deine Münzen sind noch nicht gespeichert: registriere dich, um sie zu behalten",
    guestExpiring: "{n} deiner Sweet Coins verfallen in weniger als einem Tag. Registriere dich kostenlos, um sie zu behalten.",
  },
  footer: {
    copyright: "Urheberrecht",
    takedown: "Entfernung",
    contact: "Kontakt",
    creators: "Für Creator",
    claim: "Profil beanspruchen",
    webmasters: "Webmaster",
    terms: "AGB",
    privacy: "Datenschutz",
    info: "Infos zur Website",
    telegram: "{site} auf Telegram",
  },
  report: {
    heading: "Ein Video melden",
    reason: "Grund",
    takedown: "Urheberrecht / DMCA",
    abuse: "Ich bin ohne meine Zustimmung in diesem Video zu sehen",
    minor: "Jemand in diesem Video könnte unter 18 sein",
    other: "Etwas anderes",
    url: "Videolink oder ID",
    email: "Deine E-Mail",
    details: "Details",
    detailsPlaceholder: "Was sollen wir entfernen und warum?",
    send: "Meldung senden",
  },
};
